import { useSelector } from 'react-redux';

import { selectAgreementOffer, selectAgreementPersonal, selectCurrentStep } from '../../../selectors/legalCheck';
import { EStepCode } from '../../../types/requestFormSchema';
import { AgreementContainer } from '../../../packages/Agreement/containers/AgreementContainer';
import { selectServiceMessage } from '../../../selectors/serviceMessage';

export const useFooter = () => {
  const agreementOffer = useSelector(selectAgreementOffer);
  const agreementPersonal = useSelector(selectAgreementPersonal);
  const currentStep = useSelector(selectCurrentStep);
  const { isNewYearAlertShown, isNewYearAlertShouldShown } = useSelector(selectServiceMessage);

  /** На шаге с уведомлением о работе в праздники не должно быть футера **/
  if (isNewYearAlertShouldShown && !isNewYearAlertShown) {
    return null;
  }

  switch (currentStep) {
    case EStepCode.EntitlementDocument:
      return agreementPersonal ? <AgreementContainer template={agreementPersonal} /> : null;
    case EStepCode.PayForReport:
      return agreementOffer ? <AgreementContainer template={agreementOffer} /> : null;
    default:
      return null;
  }
};
